import React from "react";
import AppLayout from "./components/layout/app-layout";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <Router>
      <div className="dark:bg-slate-800">
        <Toaster position="top-right" reverseOrder={false} />
        <AppLayout />
        
        {/* <button
          onClick={() => {
            throw new Error("Sentry Test Error from React Web App: Integration verification");
          }}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 9999,
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 15px',
            cursor: 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
          }}
        >
          Test Sentry Error
        </button> */}
      </div>
    </Router>
  );
};

export default App;
